import { render } from "./BugReports.vue?vue&type=template&id=764c6362&scoped=true&ts=true"
import script from "./BugReports.vue?vue&type=script&lang=ts"
export * from "./BugReports.vue?vue&type=script&lang=ts"

import "./BugReports.vue?vue&type=style&index=0&id=764c6362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764c6362"]])

export default __exports__